import Vue from "vue";
import Router from "vue-router";
import Portfolio from "./components/PagePortfolio.vue";
import About from "./components/PageAbout.vue";
import Login from "./components/PageLogin.vue";
import Bulk from "./components/PageBulkUpload.vue";
import ErrorNotFound from "./components/ErrorNotFound.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      component: Portfolio
    },
    {
      path: "/portfolio",
      component: Portfolio
    },
    {
      path: "/about",
      component: About
    },
    {
      path: "/login",
      component: Login
    },
    {
      path: "/bulk",
      component: Bulk
    },
    { path: "/404", component: ErrorNotFound },
    { path: "*", redirect: "/404" }
  ]
});
